module.exports = __webpack_public_path__ + "img/53.61b87041.svg";